




























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class RangeSlider extends Vue {
  @Prop({ required: true })
  private readonly min!: number;
  
  @Prop({ required: true })
  private readonly max!: number;

  @Prop({ required: true })
  private readonly step!: number;

  @Prop()
  private readonly defaultMin!: number;

  @Prop()
  private readonly defaultMax!: number;

  @Prop({ default: () => (val: number) => val.toString() })
  private readonly formatter!: (val: number) => string;

  @Prop({ default: 'var(--brand-primary-complement)' })
  private readonly trackBg!: string;

  @Prop({ default: 'var(--brand-primary)' })
  private readonly trackHighlight!: string;

  @Prop({ default: 'var(--brand-secondary)' })
  private readonly knobBg!: string;

  @Prop({ default: 'var(--brand-secondary-complement)' })
  private readonly knobHighlight!: string;

  private minVal: number = this.defaultMin || this.min;

  private maxVal: number = this.defaultMax || this.max;

  private isValueConjoined = false;

  get range(): number {
    return this.max - this.min;
  }

  get knobMinPos(): number {
    return (this.minVal - this.min) / this.range;
  }

  get knobMaxPos(): number {
    return  (this.maxVal - this.min) / this.range;
  }

  get formattedMin() {
    return this.formatter(this.minVal);
  }

  get formattedMax() {
    return this.formatter(this.maxVal);
  }

  checkIntersection() {
    const min = this.$refs['knobMin'] as HTMLSpanElement;
    const max = this.$refs['knobMax'] as HTMLSpanElement;

    const minRightEdge = min.offsetLeft + min.clientWidth;
    const maxLeftEdge = max.offsetLeft;

    this.isValueConjoined = minRightEdge >= maxLeftEdge;
  }

  initMin(track: HTMLDivElement) {
    var knob = this.$refs['knobMin'] as HTMLDivElement;

    knob.onmousedown = (e) => {
      var rect = track.getBoundingClientRect();

      document.body.onmousemove = (mme) => {
        const end = mme.pageX;

        let scaled = (end - rect.x) / track.clientWidth;

        let newVal = Math.round((scaled * this.range) / this.step) * this.step;

        this.minVal = Math.min(this.maxVal, Math.max(this.min, newVal));

        this.checkIntersection();
      }

      document.body.onmouseup = () => {
        document.body.onmousemove = document.body.onmouseup = null;
      }
    };
  }

  initMax(track: HTMLDivElement) {
    var knob = this.$refs['knobMax'] as HTMLDivElement;

    knob.onmousedown = (e) => {
      const start = e.pageX;

      var rect = track.getBoundingClientRect();

      document.body.onmousemove = (mme) => {
        const end = mme.pageX;

        let scaled = (end - rect.x) / track.clientWidth;

        let newVal = Math.round((scaled * this.range) / this.step) * this.step;

        this.maxVal = Math.max(this.minVal, Math.min(this.max, newVal));

        this.checkIntersection();
      }

      document.body.onmouseup = () => {
        document.body.onmousemove = document.body.onmouseup = null;
      }
    };
  }

  mounted() {
    var track = this.$refs['track'] as HTMLDivElement;
    
    this.initMin(track);
    this.initMax(track);
  }
}
